import * as React from 'react';

import {Button} from 'shells/button/button';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';

type Props = {
    onPrimaryCtaClick: () => void;
};

export function EmptyState(props: Props) {
    return (
        <EmptyStateLarge
            title='This is your broadcasts page'
            subtitle='Any broadcasts that you draft, send, or schedule will appear here'
            detailTextBullets={[
                'Use a broadcast to make an announcement or inform an audience of something',
                'Write and design your messages with the drag-and-drop editor — or get a quick start with one of our templates!',
                'Send messages to thousands of people at a time',
            ]}
            cta={
                <Button variant='primary' size='big' onClick={props.onPrimaryCtaClick}>
                    Create new broadcast
                </Button>
            }
            icon={
                <img
                    alt=''
                    style={{width: 160, paddingRight: 40}}
                    src='/include/images/empty-states/broadcast.svg'
                />
            }
        />
    );
}
